/* Popisky ikonových tlačítek (aria-label) — velký test funkčnosti 24. 10. 2026.
 *
 * Tlačítka jen s ikonou (tužka, šipka, hvězdička…) neměla žádný text pro čtečku
 * ani bublinu. Tady jsou jen VÝRAZY, které jinde ve slovnících chybí — „Zavřít“,
 * „Smazat“, „Uložit“, „Zrušit“, „Zpět“, „Kopírovat“ už slovníky mají.
 * Klíč = český text, hodnoty pro sk/en/uk/vi; chybějící jazyk → čeština (viz TL).
 */
export const PREKLADY_OVLADANI = {
  "Upravit": { sk: "Upraviť", en: "Edit", uk: "Редагувати", vi: "Sửa" },
  "Upravit název": { sk: "Upraviť názov", en: "Edit title", uk: "Редагувати назву", vi: "Sửa tên" },
  "Předchozí": { sk: "Predchádzajúci", en: "Previous", uk: "Попередній", vi: "Trước" },
  "Další": { sk: "Ďalší", en: "Next", uk: "Далі", vi: "Tiếp" },
  "Seřadit podle kategorie": { sk: "Zoradiť podľa kategórie", en: "Sort by category", uk: "Сортувати за категорією", vi: "Sắp xếp theo hạng" },
  "Zvětšit fotku": { sk: "Zväčšiť fotku", en: "Enlarge photo", uk: "Збільшити фото", vi: "Phóng to ảnh" },
  "Načíst znovu": { sk: "Načítať znova", en: "Reload", uk: "Завантажити знову", vi: "Tải lại" },
  "Odeslat poznámku": { sk: "Odoslať poznámku", en: "Send note", uk: "Надіслати нотатку", vi: "Gửi ghi chú" },
  "Hodnocení": { sk: "Hodnotenie", en: "Rating", uk: "Оцінка", vi: "Đánh giá" },
  "Otevřít v novém okně": { sk: "Otvoriť v novom okne", en: "Open in a new window", uk: "Відкрити в новому вікні", vi: "Mở trong cửa sổ mới" },
};
